// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.white,
    borderTopLeftRadius: theme.radius.sm,
    borderTopRightRadius: theme.radius.sm,
    boxShadow: '0px 8px 40px 0px rgba(0, 0, 0, 0.1)',
    width: '100%',
    height: '100%',
    maxHeight: '100svh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',

    [theme.fn.smallerThan('md')]: {
      width: '100vw',
      // Keep full height, but add bottom padding equal to keyboard height
      // This pushes the content up while keeping the container anchored to bottom
      height: '100svh',
      maxHeight: '100svh',
      // The key: add padding at the bottom equal to the keyboard height
      // calc(100svh - 100dvh) = keyboard height (0 when closed, positive when open)
      paddingBottom: 'calc(100svh - 100dvh)',

      // Fallback for browsers without dvh support
      '@supports not (height: 100dvh)': {
        paddingBottom: 'calc(100svh - var(--visual-viewport-height, 100svh))',
      },
    },
  },

  modalContainer: {
    borderRadius: theme.radius.md,
  },

  tabsContainer: {
    backgroundColor: theme.white,
    padding: 0,
    flexShrink: 0,
    height: 50,
    display: 'flex',
    alignItems: 'center',

    '& .mantine-Tabs-root': {
      width: '100%',
      height: '100%',
    },
  },

  tabsList: {
    display: 'flex',
    width: '100%',
    height: '100%',
    borderBottom: 'none',
    backgroundColor: 'transparent',
  },

  tab: {
    flex: 1,
    backgroundColor: 'transparent !important',
    border: 'none !important',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    height: '100%',
    padding: `${theme.other.spacing._16}px 0 !important`,
    transition: 'background-color 0.2s ease',
    borderRadius: '0 !important',

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05) !important',
    },

    '&:focus': {
      outline: `2px solid ${theme.colors.blue[5]}`,
      outlineOffset: -2,
    },

    '&[data-active="true"]': {
      backgroundColor: 'transparent !important',
      borderBottom: `2.5px solid ${theme.colors.gray2[6]} !important`,
      paddingBottom: `${theme.other.spacing._12}px !important`,
    },
  },

  tabText: {
    color: theme.colors.gray2[4],
    fontSize: 12,
    fontWeight: 900,
    lineHeight: '18px',
  },

  activeTabText: {
    color: theme.colors.gray2[6],
  },

  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.white,
    minHeight: 0,
    overflow: 'hidden',
  },

  skeletonContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.white,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.other.spacing._16,
    gap: theme.other.spacing._12,
  },

  emptyState: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.other.spacing._32,
  },

  messageComposer: {
    backgroundColor: theme.white,
    borderTop: `0.5px solid ${theme.colors.gray2[1]}`,
    padding: `${theme.other.spacing._8}px ${theme.other.spacing._16}px 0`,
    flexShrink: 0,
    position: 'relative',
    borderBottomLeftRadius: theme.radius.sm,
    borderBottomRightRadius: theme.radius.sm,
  },

  composerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${theme.other.spacing._8}px 0`,
    borderRadius: theme.radius.sm,
  },

  composerText: {
    color: theme.colors.gray2[4],
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'center',
  },

  homeIndicator: {
    backgroundColor: theme.black,
    height: 5,
    width: 134,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 100,
    margin: `${theme.other.spacing._8}px auto`,
  },
}));

export default useStyles;
